<template>
  <div :class="classList">
    <div class="st-information-box__icon">
      <component
        :is="icon"
        :size="iconSize"
        :name="iconType"
        :alt="iconAltText"
        useSvg
        inline
      />
    </div>
    <div class="st-information-box__description">
      <slot />
    </div>
  </div>
</template>

<script>
import StIcon from "../icon/Icon.vue";
import StIconLegacy from "../icon/IconLegacy.vue";
import { version } from "vue";

export default {
  name: "st-information-box",
  components: {
    StIcon,
    StIconLegacy,
  },
  computed: {
    classList() {
      const infoBox = "st-information-box";
      return [
        infoBox,
        this.small && `${infoBox}--is-small`,
        this.blueInfo && `${infoBox}--blue`,
      ];
    },
    icon() {
      return version && parseInt(version) === 3 ? "StIcon" : "StIconLegacy";
    },
    iconType() {
      return this.informationType === "success"
        ? "checkmark"
        : this.informationType === "failure"
        ? "warning-filled"
        : "info";
    },
    iconSize() {
      return this.informationType === "info" ? "sm" : "md";
    },
  },
  props: {
    iconAltText: {
      type: String,
      default: "Informationsruta",
    },
    informationType: {
      type: String,
      default: "info",
      validator(informationType) {
        return ["info", "success", "failure"].includes(informationType);
      },
    },
    small: {
      type: Boolean,
      default: false,
    },
    blueInfo: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";

.st-information-box {
  display: flex;
  align-items: center;
  border-radius: $border-radius;
  font-family: $source-sans-pro;
  background: $bg-grey;
  color: $dark-grey;
  padding: $md;
  @include medium {
    padding: $lg;
  }
  &__icon {
    margin-right: $sm;
    @include medium {
      margin-right: $lg;
      .st-icon {
        vertical-align: 0px !important;
      }
    }
  }
  &__description {
    flex: 1 1 auto;
  }
  &--is-small {
    display: inline-flex;
  }
  &--blue {
    background: #e3f3ff;
  }
}
</style>
